export const PRACTICE_SHAPER_ENTITIES = new Set([
  'Taxonomy',
  'DomainType',
  'SystemPrototypeType',
  'SystemType',
  'ComponentType',
  'Trait',
]);

export const PROJECT_TYPE_ENTITIES = new Set(['SystemType', 'ComponentType']);

export const CLASS_DETAILS_SYSTEM_TYPE_ANNOTATION =
  'witboost.com/classDetails.systemType';
